import { render, staticRenderFns } from "./KidsAuditLogs.vue?vue&type=template&id=013eafa5&scoped=true"
import script from "./KidsAuditLogs.vue?vue&type=script&lang=js"
export * from "./KidsAuditLogs.vue?vue&type=script&lang=js"
import style0 from "./KidsAuditLogs.vue?vue&type=style&index=0&id=013eafa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013eafa5",
  null
  
)

export default component.exports